import { Component, OnInit } from '@angular/core';
import { InscripcionPlanCompensacion } from 'src/app/models/inscripcionPlanCompensacion.model';
import { Router } from '@angular/router';
import { GlobalService } from 'src/app/shared/global.service';
import { UrlService } from 'src/app/shared/services/url.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { AlertService } from 'src/app/shared/services/alert.service';
import { UtilService } from 'src/app/shared/services/util.service';
import { UrlControl } from 'src/app/shared/models/generic.model';
import { ConstantesService } from 'src/app/shared/services/constantes.service';
import { SolicitudAjusteCompensacion } from 'src/app/models/solicitudAjusteCompensacion.model';

@Component({
    selector: 'app-lista-ajuste-dependencia',
    templateUrl: './lista-ajuste-dependencia.component.html',
    styleUrls: ['./lista-ajuste-dependencia.component.scss']
})
export class ListaAjusteDependenciaComponent implements OnInit {

    tipoDocumento: string;
    numeroDocumento: string;

    filtro: string;
    solicitudSeleccionada: SolicitudAjusteCompensacion;
    listaSolicitudes: SolicitudAjusteCompensacion[];
    listaSolicitudesFiltro: SolicitudAjusteCompensacion[];

    constructor(
        private router: Router,
        private global: GlobalService,
        private urlService: UrlService,
        private spinner: NgxSpinnerService,
        private alertService: AlertService,
        private utilService: UtilService) {
    }

    ngOnInit() {
        this.tipoDocumento = sessionStorage.getItem('tipoDocumento');
        this.numeroDocumento = sessionStorage.getItem('numDocumento');
        this.consultarSolicitudes();
    }

    /**
     * Método que permite filtar las solicitudes de ajuste mostradas al usuario
     * @function filtrarSolicitudes
     * @author dfranco@asesoftware.com
     */
    public filtrarSolicitudes() {
        if (this.filtro && this.filtro.trim() !== '') {
            this.listaSolicitudesFiltro = this.listaSolicitudes.filter(
                item => {
                    const filtroTemp = this.filtro.toUpperCase();
                    const documento = item.numeroIdFuncionario;
                    const nombre =  item.nombreCompleto.toUpperCase();
                    return documento.indexOf(filtroTemp) !== -1 || nombre.indexOf(filtroTemp) !== -1;
                }
            );
            if (this.listaSolicitudesFiltro.length === 0) {
                this.alertService.generateAlertError(ConstantesService.MENSAJE_NO_HAY_DATOS_BUSQUEDA_SOLICITUD_AJUSTE, '');
            }
        } else {
            this.listaSolicitudesFiltro = this.listaSolicitudes;
        }
    }

    /**
     * Método que muestra el detalle de una solicitud de ajuste
     * @function verDetalle
     * @author dfranco@asesoftware.com
     * @param  solicitud Solicitud seleccionada en la tabla
     */
    public verDetalle(solicitud: SolicitudAjusteCompensacion) {
        this.solicitudSeleccionada = solicitud;
    }

    /**
     * Método que permite recargar el contenido de la página
     * @author dfranco@aseosftware.com
     * @function recargarPagina
     */
    recargarPagina() {
        this.solicitudSeleccionada = undefined;
        this.consultarSolicitudes();
    }

    /**
     * Método que permite consultar el listado de solicitudes de ajuste de las personas asociadas
     * a la dependencia donde el funcionario es jefe
     * @function consultarSolicitudes
     * @author dfranco@asesoftware.com
     */
    public consultarSolicitudes() {
        this.spinner.show();
        const serviceProvider = 'getSolicitudesPorDependencia';
        const queryParams: Array<[string, string]> = new Array<[string, string]>();
        queryParams.push(['tipoDocumento', this.tipoDocumento]);
        queryParams.push(['numeroDocumento', this.numeroDocumento]);
        const url = this.urlService.getUrlFuncionario(new UrlControl(serviceProvider, null, queryParams),
            this.urlService.hostAPI_FUNCIONARIOS);
        this.global.getGenerico(url).subscribe(
            data => {
                if (data && data.length > 0) {
                    this.listaSolicitudes = data;
                    this.listaSolicitudesFiltro = data;
                } else {
                    this.alertService.generateAlertError(ConstantesService.MENSAJE_NO_EXISTEN_SOLICITUDES_AJUSTAR, '');
                }
                this.spinner.hide();
            }, err => {
                if (err.status === '500') {
                    this.catchException(err.error.message);
                } else {
                    this.catchException('Error al consultar plan de compensación actual');
                }
            }
        );
    }

    /**
     * Método de control de Excepciones
     * @function cathException
     * @author dfranco@asesoftware.com
     * @param  error  mensaje saliente respecto al error ocurrido
     */
    catchException(error) {
        this.utilService.cathException(error, this.alertService, this.spinner);
    }

}